export const appleStoreLink = 'https://apps.apple.com/us/app/wae-holdings-llc/id6479449903';
export const androidStoreLink = 'https://play.google.com/store/apps/details?id=com.wae.android';
